<template>
    <span v-if="mostrarBtnSelecionar">
        <b-button variant="primary" @click.stop="abrirModal()" class="float-right">
            <span>
                <i class="fa fa-users"></i> Selecionar Destinatários
            </span>
        </b-button>
        <b-modal id="modalDestinatarios" v-model="mostrarModal" size="lg" @show="atualizarModal()">
            <div slot="modal-title">Destinatários</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Para">
                        <b-form-select :plain="true" :options="paraOpcoes" v-model="paraSel"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="paraSel == 1">
                <b-col sm="12">
                    <app-tabela
                        idTabela="tblFornecedores"
                        :itens="fornecedores"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                    >
                        <template slot="cpfCnpj" slot-scope="data">
                            <span>{{ data.cpfCnpj | toCpfCnpjMasked }}</span>
                        </template>
                        <template slot="fornecedorSel" slot-scope="data">
                            <b-form-checkbox :value="data" v-model="selecionados"></b-form-checkbox>
                        </template>
                    </app-tabela>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">Cancelar</b-button>
                <b-button
                    variant="primary"
                    :disabled="desabilitarSelecionar"
                    @click.stop="selecionarDestinatarios()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-check-square-o"></i> Selecionar
                    </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import MensagensServicos from './MensagensServicos'

export default {
	props: {
		mensagem: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			paraOpcoes: [
				{ text: 'TODOS OS FORNECEDORES', value: 0 },
				{ text: 'FORNECEDORES SELECIONADOS', value: 1 }
			],
			paraSel: 0,
			mostrarModal: false,
			selecionados: [],
			fornecedores: [],
			campos: [
				{
					key: 'fornecedorSel',
					label: ''
				},
				{
					key: 'cpfCnpj',
					label: 'CNPJ',
					sortable: true,
					filterable: true
				},
				{
					key: 'razaoSocial',
					label: 'Fornecedor',
					sortable: true,
					filterable: true
				}
			],
			itensPorPagina: 10
		}
	},

	methods: {
		abrirModal() {
			this.mostrarModal = true
		},

		fecharModal() {
			this.mostrarModal = false
		},

		atualizarModal() {
			if (
				this.mensagem.destinatarios &&
				this.mensagem.destinatarios.length > 0
			) {
				this.paraSel = 1
				this.selecionados = this.mensagem.destinatarios
			}
		},

		selecionarDestinatarios() {
			this.$emit('atualizarDestinatarios', this.selecionados)
			this.fecharModal()
		},

		obterFornecedores() {
			this.$store.dispatch('addRequest')
			MensagensServicos.obterFornecedores().then(response => {
				if (response) {
					if (response.success) {
						this.fornecedores = response.data
					} else {
						this.$toast.error(
							'Erro ao obter fornecedores!!!',
							'ERROR',
							this.$toastConfig.error
						)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		}
	},

	computed: {
		mostrarBtnSelecionar() {
			let retorno =
				this.$store.getters.fornecedor.fornecedorId === null &&
				this.mensagem.status == 0
			return retorno
		},

		desabilitarSelecionar() {
			if (this.paraSel == 1 && this.selecionados.length == 0) return true
			return false
		}
	},

	watch: {
		paraSel(to) {
			if (to == 0) {
				this.selecionados = []
			} else {
				this.obterFornecedores()
			}
		}
	},

	validations: {
		codEvento: {
			required
		}
	}
}
</script>
